import React from 'react';
import './NoContent.scss';

export const NoContent = () => {
  return (
    <div className='pertamina no-content'>No Available Data</div>
  );
};
